var Vendd = (function (Vendd) {
	'use strict';

	Vendd.MessageBus.subscribe(Vendd.Installments.Messages.GetInstallmentsData, Vendd.Installments, function (envelope) {
		var options = {
			url: 'api/Installments/GetInstallmentsData',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Installments, new Vendd.Installments.Messages.GetInstallmentsDataSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Installments, new Vendd.Installments.Messages.GetInstallmentsDataFailed(response));
		}

		Vendd.Service.call(options);
	});

	return Vendd;

})(Vendd || {});
